import { createUtilDebugLogger as createDebug } from './createLogger';

const _DEFAULT_TRIM_TEST_FUNC = (e) => (e === null || e === undefined);

const _isArray = (x) => Array.isArray(x);
const _isString = (x) => typeof x === `string`;

const _objArray = (obj) => Object.entries(obj);

// removes unwanted values in an object or array
function _trim(collection,
               trimTestFunc = _DEFAULT_TRIM_TEST_FUNC) {
  if (Array.isArray(collection))
    return collection.filter(item => !trimTestFunc(item));
  else
    for (let prop in collection)
      if (collection.hasOwnProperty(prop))
        if (trimTestFunc(collection[prop]))
          delete collection[prop];
  return collection;
}

// callback-style for-in loop
function _forin(obj, callback) {
  if (typeof callback !== 'function' ||
    typeof obj !== 'object') return;

  let index = 0;
  for (let prop in obj)
    if (obj.hasOwnProperty(prop))
      callback(prop, obj[prop], index++, obj);
}

// gets arbitrary values from a deeply-nested object
// path can be a string (e.g. _get(foo, `x.y.z`) )
//      ... or an array (e.g. _get(foo, [`x`, `y`, `z`) )
function _get(obj, path, verbose) {
  let debug = createDebug(verbose);
  debug.enter(`_get`);
  debug.log(`obj:`, obj, `path:`, path);

  if (typeof path === `string`)
    path = path.split(`.`);

  let ref = obj;
  for (let i = 0; i < path.length; i++) {
    debug.log(`ref:`, ref, `getting: ${path[i]}`);
    if (!!ref) ref = ref[path[i]];
    else return null;
  }

  debug.log(`ref:`, ref);
  debug.exit();
  return ref;
}


function toTitleCase(str) {
  return str.replace(
      /\w\S*/g,
      function(txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      }
  );
}

function capitalizeJobTitle(title) {
  let acronyms = [
        'Vp', 'Cto', 'Cmo', 'Cxo', 'Ciso', 'Cso', 'Cfo', 'Cro', 'Ceo', 'Coo', 'Sox', 'Sdr', 'Dba', 'Sap', 'Css',
        'Pm', 'Sql', 'Php', 'Html', 'Cfp', 'Ptw', 'Hr', 'It', 'Qa'],
      stopWords = ['Of', 'And'],
      splitCapped = toTitleCase(title).trim().split(' ');


  acronyms.forEach(acronym => {
    for(let i = 0; i < splitCapped.length; ++i) {
      if(splitCapped[i] === acronym)
        splitCapped[i] = splitCapped[i].replace(RegExp(acronym, 'i'), acronym.toUpperCase());
      else if(stopWords.includes(splitCapped[i]))
        splitCapped[i] = splitCapped[i].toLowerCase();
    }
  });
  return splitCapped.join(' ');
}

/*
function Map(object) {
  this.prototype = Object.prototype;
  this.prototype.constructor = Map;
  for (let prop in object) {
    if (object.hasOwnProperty(prop)) {
      this[prop] = object[prop];
    }
  }
  this.prototype.forin = function(callback) {
    let index = 0;
    for (let prop in this) {
      if (this.hasOwnProperty(prop)) {
        callback(prop, this[prop], index++, this);
      }
    }
  };
  this.prototype.map = function(callback) {
    let map = {};
    let index = 0;
    for (let prop in this) {
      if (this.hasOwnProperty(prop)) {
        map[prop] = callback(prop, this[prop], index++, this);
      }
    }
    return map;
  };
}
*/

export {
  _get,
  _trim,
  _forin,
  _isArray,
  _isString,
  _objArray,
  toTitleCase,
  capitalizeJobTitle
}



// WEBPACK FOOTER //
// ./src/utils/utils.js